<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Normes Administratives" />
            <NormeAdministrative />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import NormeAdministrative from './NormeAdministrative.vue'


export default {
    name: 'AnimateursPage',
    components: {
        NavBar,
        PageTitle,
        NormeAdministrative,
        FooterComp,
    }
}
</script>